export default function({ state, commit, dispatch }, query) {
    const providerId = query.id
    const urlQuery = query.next ? { next: query.next, limit: 500 } : { limit: 500 }
    return dispatch(
        "get",
        {
            url: "/provider/" + query.id + "/linedown",
            query: urlQuery,
        },
        {
            root: true,
        }
        )
        .then((response) => {
            commit("addProviderPatients", {
                id: query.id,
                patient: response.patients.map((patient) => (
                    {
                        ...patient,
                        next_schedule: null,
                        previous_schedule: patient.next_schedule
                    }
                ))
            })
            if (response.next)
            dispatch("loadLinedown", {
                ...query,
                next: response.next,
            })
        })
        .catch((error) => {
            throw error
        })
}
